



























import {Vue, Prop, Component} from 'vue-property-decorator';
import binaryDownload from '@/services/BinaryDownloader';

@Component
export default class ReprintModal extends Vue {
    @Prop() public formId!: number;

    public async print(type: string, id: number) {
        if (!id) {
            return;
        }

        try {

            const url = `/print/v1/${type}/print/${id}`;
            await binaryDownload('GET', url);

        } catch (err) {
            // TODO:
        }
    }

    public show(): void {
        this.$nextTick(() => (this.$refs.modal as any).show());
    }
}
